<template>
    <router-link :to="url" class="nounderline">
        <div class="paper">
            <div class="mainimagecontainer">
                <img class="mainimage" :src="value.backgroundImage || getDefaultBackground()" />
                <div v-if="value.thumbnail" class="logoimagecontainer text-center">
                    <img class="logo" :src="value.thumbnail" />
                </div>
                <div v-if="live" class="live">LIVE NOW</div>
            </div>

            <div class="bottompart">
                <div class="timelabel">
                    <font-awesome-icon class="mr-1 icon" icon="calendar-alt" />
                    {{ date }}
                    <font-awesome-icon class="mr-1 ml-3 icon" icon="clock" />
                    {{ time }}
                </div>
                <div class="title mb-2">{{ value.title }}</div>
                <div class="description mb-2">{{ descriptionText }}</div>
            </div>
        </div>
    </router-link>
</template>

<script>
import moment from 'moment';
import { getVFairEventRoute } from '~/router';

import defaultBackground from '~/assets/img/vcf/event-default-bg.png';

export default {
    name: 'Event',
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        vFairId: {
            type: String,
            default: '',
            required: true,
        },
    },
    computed: {
        live() {
            const start = new moment(this.value.startTime);
            const end = new moment(this.value.endTime);
            return moment().isBetween(start, end);
        },
        date() {
            const timestamp = new moment(this.value.startTime);
            return timestamp.format('D MMM');
        },
        time() {
            const timestamp = new moment(this.value.startTime);
            return timestamp.format('H:mm');
        },
        url() {
            return getVFairEventRoute(this.vFairId, this.value.id);
        },
        descriptionText() {
            var temp = document.createElement('div');
            temp.innerHTML = this.value.description;
            return temp.textContent || temp.innerText || '';
        },
    },
    methods: {
        getDefaultBackground() {
            return defaultBackground;
        },
    },
};
</script>

<style scoped>
.paper {
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    padding-bottom: 10px;
}
.mainimagecontainer {
    width: 100%;
    padding-top: 50px;
    position: relative; /* If you want text inside of it */
}

.mainimage {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 5px 5px 0 0;
    object-fit: cover;
}

.nounderline {
    text-decoration: none;
}

.logoimagecontainer {
    margin-left: 14px;
    width: 74px;
    height: 47px;
    border-radius: 5px;
    border-width: 1px;
    border-color: #b7b7b7;
    background: #fff;
    padding: 2px;
    border-style: solid;
    transform: translateY(-50%);
    overflow: hidden;
    position: absolute;
}

.live {
    color: #fff;
    font-size: 14px;
    position: absolute;
    background: #f00;
    padding: 2px;
    top: 7px;
    right: 14px;
}

.logo {
    max-width: 100%;
    max-height: 100%;
}

.bottompart {
    border-radius: 0px 0px 5px 5px;
    border-width: 0px 1px 1px 1px;
    border-color: #b7b7b7;
    border-style: solid;
}

.timelabel {
    margin-left: 116px;
    padding-top: 5px;
    font-size: 12px;
    color: #323c53;
    text-transform: uppercase;
}

.icon {
    color: #b7b7b7;
}

.title {
    margin-left: 14px;
    margin-top: 5px;
    font-size: 14px;
    color: #323c53;
}
.description {
    width: 100%;
    padding-left: 14px;
    padding-right: 14px;
    margin-top: 5px;
    font-size: 12px;
    color: #b7b7b7;
    max-lines: 2;
    height: 40px;
    overflow: hidden;
    background: -webkit-linear-gradient(#444, #fff);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
